/**
 * This function converts html string to html element
 *
 * @param {string} htmlStr - html string
 * @returns {HTMLElement} - html element
 */
const getDOMfromString = htmlStr => {
    const temp = document.createElement('div');
    temp.innerHTML = htmlStr;
    return temp.firstElementChild;
};

export default getDOMfromString;
